import AddressTypes from 'common/Forms/AddressTypes';
import { ConcatAddressLine } from 'common/Addresses/AddressFormatters/Shared/AddressFormatHelper';

const splitByFirstComma = (value) => {
  if (typeof value !== 'string') {
    return ['', ''];
  }

  const commaIndex = value.indexOf(',');
  if (commaIndex === -1) {
    return [value.trim(), ''];
  }

  return [
    value.slice(0, commaIndex).trim(),
    value.slice(commaIndex + 1).trim()
  ];
};

function GetFormFieldPathValueMap(addressPath, wellFormedAddress) {
  const streetLine1 = wellFormedAddress?.addressLine1 ?? wellFormedAddress?.line1;
  const streetLine2 = wellFormedAddress?.addressLine2 ?? wellFormedAddress?.line2;

  const fieldPathValueDictionary = [
    {
      key: `${ addressPath }.line1`,
      value: ConcatAddressLine([streetLine1, streetLine2])
    },
    {
      key: `${ addressPath }.line2`,
      value: ''
    },
    { key: `${ addressPath }.line3`, value: wellFormedAddress?.addressLine3 ?? wellFormedAddress?.line3 },
    { key: `${ addressPath }.line4`, value: wellFormedAddress?.addressLine4 ?? wellFormedAddress?.line4 },
    { key: `${ addressPath }.postalCode`, value: wellFormedAddress?.addressPostalCode ?? wellFormedAddress?.postalCode },
    { key: `${ addressPath }.country`, value: wellFormedAddress?.addressCountry ?? wellFormedAddress?.country }
  ];

  return fieldPathValueDictionary;
}

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  switch (addressProps?.addressType) {
    case AddressTypes.Current:
      return GetFormFieldPathValueMap('customer.residenceAddress', wellFormedAddress);
    case AddressTypes.Mailing:
      return GetFormFieldPathValueMap('customer.mailingAddress', wellFormedAddress);
    default:
      break;
  }
}

function CreateWellFormedAddress(formAddress) {
  const [line1, line2FromStreet] = splitByFirstComma(formAddress?.line1);

  const wellFormedAddress = {
    line1,
    line2: line2FromStreet || formAddress?.line2 || '',
    line3: formAddress?.line3 || '',
    line4: formAddress?.line4 || '',
    postalCode: formAddress?.postalCode || '',
    country: formAddress?.country || ''
  };

  return wellFormedAddress;
}

export function GetWellFormedAddress(addressProps, addressValues) {
  switch (addressProps?.addressType) {
    case AddressTypes.Current:
      return CreateWellFormedAddress(addressValues?.customer?.residenceAddress);
    case AddressTypes.Mailing:
      return CreateWellFormedAddress(addressValues?.customer?.mailingAddress);
    default:
      break;
  }
}
